function getCheckInDates(data, departureDateStr, arrivalDateStr) {
    var checkInDate = data.checkInDate && data.checkInDate !== departureDateStr;
    var checkOutDate = data.checkOutDate && data.checkOutDate !== arrivalDateStr;

    return checkInDate || checkOutDate ?
        [Odigeo.Utils.parseDate(data.checkInDate), Odigeo.Utils.parseDate(data.checkOutDate)] : null;
}

const getOneLineIatas = (segments) => segments.reduce((text, value, idx) => {
    return text + (idx > 0 ? ', ' : '') + wrapIata(value.departure.iata) + '-' + wrapIata(value.destination.iata);
}, '');

const wrapIata = (iata) => `<span class="odf-display-inline-block">${iata}</span>`;

const getDates = (segments) => {
    let arrivalDateStr;
    const stringFormat = Odigeo.Utils.formatDate.masks.isoDateTime;
    const hourSuffix = 'T00:00:00';
    if (segments.length > 1) {
        arrivalDateStr = Odigeo._.get(segments[segments.length -1], 'dateStr');
    }
    return [
        Odigeo.Utils.parseDate(segments[0].dateStr + hourSuffix, stringFormat),
        arrivalDateStr ? Odigeo.Utils.parseDate(arrivalDateStr + hourSuffix, stringFormat) : arrivalDateStr,
    ];
};

const getCityNames = (segment) => {
    return {
        originCityName: segment.departure.name,
        destinationCityName: segment.destination.name,
    };
};

function getUpdatedModel(data) {
    var priceText = Odigeo._.gt(data.totalPrice, 0) ? getPriceText.call(this, data.totalPrice) : '';
    var itinerary = getItinerary(data.searchSegments[0], Odigeo._.isString(priceText) ? priceText.length : 0);
    var departureDateStr = data.searchSegments[0].dateStr;
    var arrivalDateStr = Odigeo._.get(data.searchSegments[1], 'dateStr');
    var hasRooms = !Odigeo._.isUndefined(data.rooms);
    var roomsNumber = Odigeo._.get(data, 'rooms.length', 0);

    return {
        legs: [itinerary],
        dates: getDates(data.searchSegments),
        checkingDates: getCheckInDates(Odigeo._.pick(data, 'checkInDate', 'checkOutDate'), departureDateStr, arrivalDateStr),
        passengers: Odigeo._.pick(data, 'numAdults', 'numChildren', 'numInfants'),
        priceText: priceText,
        roomsNumber: roomsNumber,
        hasRooms: hasRooms,
        isMultidestination: data.type === 'multipleTrip',
        cityNames: getCityNames(data.searchSegments[0]),
        iatas: getIatas(data.searchSegments[0]),
        iatasString: getOneLineIatas(data.searchSegments),
    };
}

function getIatas(segment) {
    return {
        originIata: segment.departure.iata,
        destinationIata: segment.destination.iata,
    };
}

function getItinerary(segment, priceLength) {
    var maxTotalLength = 54;
    var maxItineraryLength = maxTotalLength - priceLength;
    var getValuesList = function(data) {
        return Odigeo._.toArray(Odigeo._.pick(data, ['city', 'name', 'iata']));
    };
    var sizedCombination = Odigeo.Utils.fitStringsCombination(
        maxItineraryLength,
        getValuesList(segment.departure),
        getValuesList(segment.destination)
    );

    return {
        originCity: sizedCombination[0],
        destinationCity: sizedCombination[1],
    };
}

function getPriceText(totalPrice) {
    var formatCurrency = Odigeo._.partial(Odigeo.Utils.formatCurrency, _, Odigeo._.extend({}, Odigeo.Utils.Currency, {decimalPlaces: 0}));

    return this.widget.view.keys.resultsSummaryTitle + ' ' + formatCurrency(Math.ceil(totalPrice));
}

function getTotalPassengers() {
    return _(this.model.get('passengers')).values().reduce(Odigeo._.add, 0);
}

module.exports = {
    getUpdatedModel,
    getItinerary,
    getTotalPassengers,
};
